import { useEffect } from "react";

export function usePwaInstallSilent() {
  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault(); // prevent Chrome default prompt

      // Save current path for redirect after install
      localStorage.setItem("pwaStartPath", window.location.pathname);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);
}
